<template>
  <!-- dialog add people -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'900px'"
    :modalAppendToBody="modalAppendToBody"
    :appendToBody="true"
    :classDialog="'add-people-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle">Thêm người phối hợp</h3>
      <el-row :gutter="12" class="margin-bottom-10">
        <!-- <el-col :span="7">
          <el-checkbox
            size="mini"
            :border="true"
            v-model="checkAll"
            @change="checkAllChange"
            >Chọn tất cả
          </el-checkbox>
        </el-col> -->
        <el-col :span="17" class="flex-row flex__left">
          <el-input
            v-model="keyword"
            size="mini"
            placeholder="Gõ tên để bắt đầu tìm kiếm"
            class="style-fullWidth input-border__bottom input-border__radius__0"
            @keydown.enter.exact.native="search"
          ></el-input
          >&nbsp;&nbsp;
        </el-col>
      </el-row>

      <el-tree
        :props="selectedUserDeptRoleIds"
        :data="dataTree"
        default-expand-all
        node-key="id"
        ref="tree"
        class="filter-tree-task"
        highlight-current
      >
        <div
          class="custom-tree-node flex-row flex__between width__100"
          slot-scope="{ node, data }"
        >
          <div class="field-1">
            <span>
              <el-checkbox
                :value="checkedData(data)"
                size="medium"
                @change="checkedChangeEvent(data)"
              >
                <span class="font-size__medium">&nbsp;{{ data.label }}</span>
              </el-checkbox>
            </span>
          </div>
        </div>
      </el-tree>
      <!-- <el-checkbox-group v-model="selectedUserDeptRoleIds">
        <el-table
          ref="multipleTable"
          :data="userDeptRoleViews"
          style="width: 100%"
          size="mini"
          :show-header="false"
          max-height="300"
        >
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-checkbox
                :label="scope.row.id"
                class="checkbox-add-people"
                size="medium"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip>
            <template slot-scope="scope" class="">
              <span class="userShortInfo" @click="itemClicked(scope.row)">
                <div class="name">{{ scope.row.fullName }}</div>
                <div class="role">
                  {{ scope.row.positionName || scope.row.roleName }} -
                  {{ scope.row.deptName }}
                </div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group> -->
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="submit">
          <i class="fas fa-check-circle"></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="cancel">
          <i class="fas fa-ban"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import departmentService from "../../../services/departmentService";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import h from "../../../services/h";
import utils from "../../../services/utils";
export default {
  name: "dialog-add-people",
  props: [
    "isOpen",
    "addedPeopleIds",
    "taskId",
    "modalAppendToBody",
    "delegatorId",
  ],
  filters: { buildShortNameFilter },
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    VuePerfectScrollbar,
  },
  data() {
    return {
      keyword: null,
      selectedUserDeptRoleIds: [],
      userDeptRoleViews: [],
      allUserDeptRoleViews: [],
      checkAll: false,
      dataTree: null,
      departments: null,
      selectedHandlersData: [],

      settings: {
        maxScrollbarLength: 350,
      },
    };
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole
        ? this.$store.getters.userDeptRole.deptId
        : null;
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
  },

  watch: {
    selectedUserDeptRoleIds(newValue) {
      this.checkAll =
        newValue &&
        newValue.length &&
        newValue.length === this.userDeptRoleViews.length;
    },
  },

  created() {
    this.loadDerpartment().then(() => {
      this.loadAssigners().then(() => {
        this.filterAddedPeople();
        this.userDeptRoleViews = this.allUserDeptRoleViews;
        this.convertDataToTree(this.allUserDeptRoleViews);
      });
    });
  },

  methods: {
    checkedData(data) {
      return !!this.selectedHandlersData.find(
        (item) => item.data.id === data.id
      );
    },
    checkedChangeEvent(data) {
      this.checkedChange(data, true);
      // this.groupActors();
    },

    groupActors() {
      this.groups = utils.groupActors(
        this.selectedHandlersData,
        this.groupFilters
      );
    },

    checkedChange(data, multi) {
      let checked = !this.checkedData(data);
      if (!this.getChildOfNode(data).length) {
        this.addOrRemoveToSelectedHandlers(data);
      }
      if (multi && this.getChildOfNode(data).length) {
        this.checkedAllChildren(data, checked);
      }
      this.updateCheckedForParent(data, checked);
    },

    updateCheckedForParent(data, checked) {
      let parent = null;
      if (data.deptId) {
        parent = this.departments.find((item) => item.id === data.deptId);
      } else {
        parent = this.departments.find((item) => item.id === data.parentId);
      }
      if (!checked) {
        if (parent) {
          let index = h.indexOf(
            this.selectedHandlersData,
            (item) => item.data.id === parent.id
          );
          if (index > -1) {
            this.selectedHandlersData.splice(index, 1);
            this.updateCheckedForParent(parent, false);
          }
        }
      } else {
        if (parent) {
          let childOfParent = this.getChildOfNode(parent);
          let selected = this.selectedHandlersData.filter(
            (item) =>
              item.data.parentId === parent.id || item.data.deptId === parent.id
          );
          if (selected.length === childOfParent.length) {
            this.selectedHandlersData.push({ data: parent });
            this.updateCheckedForParent(parent, true);
          }
        }
      }
    },

    addOrRemoveToSelectedHandlers(data) {
      let index = h.indexOf(
        this.selectedHandlersData,
        (item) => item.data.id === data.id
      );
      if (!this.checkedData(data)) {
        this.selectedHandlersData.push({
          data: data,
        });
      } else {
        this.selectedHandlersData.splice(index, 1);
      }
      if (this.getChildOfNode(data).length) {
        this.checkedAllChildren(data, !this.checkedData(data));
      }
    },

    getChildOfNode(data) {
      return this.departments
        .concat(this.allUserDeptRoleViews)
        .filter((item) => item.parentId === data.id || item.deptId === data.id);
    },

    checkedAllChildren(data, checked) {
      let children = this.getChildOfNode(data);
      h.each(children, (child) => {
        let checkedState = this.checkedData(child);
        if (checkedState !== checked) {
          this.checkedChange(child, this.getChildOfNode(child).length);
        }
      });
    },

    filterAddedPeople() {
      this.allUserDeptRoleViews = h.findAll(
        this.allUserDeptRoleViews,
        (userDeptRoleView) =>
          this.addedPeopleIds.indexOf(userDeptRoleView.id) === -1
      );
    },

    loadAssigners() {
      return userDeptRoleViewService
        .findAllCoordinatorForTask(
          this.taskId,
          {
            sort: ["deptName", "positionOrder", "fullName"],
          },
          this.delegatorId
        )
        .then((response) => {
          this.allUserDeptRoleViews = response.data.map((item) => {
            return {
              ...item,
              label:
                item.fullName +
                ` (${item.positionName} - ${item.deptName})`,
              selected: true,
            };
          });
        });
    },

    loadDerpartment() {
      return departmentService
        .findAllCurrentAndIncludeSubDepts()
        .then((res) => {
          this.departments = res.data;
        });
    },

    convertDataToTree(allUserDeptRoleViews) {
      let treeData = [];
      let rootDept = null;
      let childrenRoot = [];
      let currentDeptId = this.$store.getters.userDeptRoles.filter(
        (item) => item.id === this.$store.getters.userDeptRoleId
      )[0];
      this.departments.map((item) => {
        let children = allUserDeptRoleViews.filter(
          (user) => user.deptId === item.id
        );
        if (item.id === currentDeptId.deptId) {
          rootDept = {
            ...item,
            children: children.map((child) => {
              return {
                ...child,
                parent: item,
              };
            }),
          };
        } else {
          if (children.length) {
            childrenRoot.push({
              ...item,
              label: item.deptName,
              children: children.map((child) => {
                return {
                  ...child,
                  parent: item,
                };
              }),
            });
          }
        }
      });
      let childrenRootEmpl = allUserDeptRoleViews.filter(
        (user) => user.deptId === rootDept.id
      );
      if (rootDept && (childrenRoot.length || childrenRootEmpl.length)) {
        treeData.push({
          ...rootDept,
          label: rootDept.deptName,
          children: childrenRootEmpl.concat(childrenRoot),
        });
      }
      this.dataTree = treeData;
    },

    itemClicked(item) {
      let index = this.selectedUserDeptRoleIds.indexOf(item.id);
      index === -1
        ? this.selectedUserDeptRoleIds.push(item.id)
        : this.selectedUserDeptRoleIds.splice(index, 1);
    },

    checkAllChange() {
      this.selectedUserDeptRoleIds = this.checkAll
        ? h.collect(this.userDeptRoleViews, (item) => item.id)
        : [];
    },

    validate() {
      if (
        !this.selectedUserDeptRoleIds ||
        !this.selectedUserDeptRoleIds.length
      ) {
        this.$message({
          message: "Vui lòng chọn Người phối hợp",
          type: "error",
        });
        return false;
      }

      return true;
    },

    submit() {
      this.selectedUserDeptRoleIds = this.selectedHandlersData
        .filter((item) => item.data.selected)
        .map((item) => item.data.id);
      if (!this.validate()) return;
      let selectedUserDeptRoleViews = h.findAll(
        this.userDeptRoleViews,
        (item) =>
          this.selectedUserDeptRoleIds &&
          this.selectedUserDeptRoleIds.indexOf(item.id) !== -1
      );
      this.$emit("submit", { userDeptRoleViews: selectedUserDeptRoleViews });
    },

    cancel() {
      this.$emit("closeDialog");
    },

    search() {
      this.checkAll = false;
      let userDeptRoleViews = this.keyword
        ? h.findAll(this.allUserDeptRoleViews, (userDeptRoleView) =>
            utils.isUserDeptRoleMatchWithQueryByName(
              userDeptRoleView,
              this.keyword
            )
          )
        : this.allUserDeptRoleViews;
      this.convertDataToTree(userDeptRoleViews);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/job/create-job/dialog-add-people.vue